import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'

const FormRow = overrideOptional(
  styled.div<{
    single?: boolean
    double?: boolean
    triple?: boolean
  }>`
    width: 100%;

    ${(props) =>
      props.single &&
      css`
        display: flex;

        > div {
          width: 50%;
          padding: 0 ${theme.spacing.x1}px 0 0;
        }
      `}

    ${(props) =>
      props.double &&
      css`
        display: flex;

        > div {
          width: 50%;
          padding: 0 ${theme.spacing.x1}px 0 0;

          &:last-of-type {
            padding: 0 0 0 ${theme.spacing.x1}px;
          }
        }
      `}

        ${(props) =>
      props.triple &&
      css`
        display: flex;

        > div {
          width: calc(100% / 3);
          padding: 0 ${theme.spacing.x1}px 0 0;

          &:nth-of-type(2) {
            padding: 0 ${theme.spacing.x1}px;
          }

          &:nth-of-type(3) {
            padding: 0 0 0 ${theme.spacing.x1}px;
          }
        }
      `}
  `,
)

export default FormRow
